import { Link } from 'react-router-dom';
import { Logo } from './UI';

export default function Footer() {
  return (
    <footer>
      <div className="container">
        <div className="footer-grid">
          <div className="footer-brand">
            <Logo style={{ fontSize: '1.375rem' }} />
            <p>Türkiye'nin ilk holistik Muhasebe ekosistemi. Tüm e-dönüşüm paydaşları bir arada ve entegre muhasebe teknolojileri ağınız.</p>
            <div className="footer-social" style={{ marginTop: 20 }}>
              {/* <a className="social-btn" href="#" title="LinkedIn">
                <svg fill="currentColor" viewBox="0 0 24 24">
                  <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
                </svg>
              </a>
              <a className="social-btn" href="#" title="Twitter/X">
                <svg fill="currentColor" viewBox="0 0 24 24">
                  <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
                </svg>
              </a> */}
              {/* <a className="social-btn" href="#" title="YouTube">
                <svg fill="currentColor" viewBox="0 0 24 24">
                  <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
                </svg>
              </a> */}
            </div>
          </div>

          <div className="footer-col">
            <h5>Hızlı Linkler</h5>
            <ul className="footer-links">
              <li><Link to="/">Ana Sayfa</Link></li>
              <li><Link to="/yetenekler">Yetenekler</Link></li>
              <li><Link to="/kurumsal">Kurumsal</Link></li>
              <li><Link to="/iletisim">İletişim</Link></li>
              <li><Link to="/iletisim">Demo Talep</Link></li>
            </ul>
          </div>

          <div className="footer-col">
            <h5>Modüller</h5>
            <ul className="footer-links">
              <li><Link to="/yetenekler">E-belge Modülü</Link></li>
              <li><Link to="/yetenekler">E-Defter Modülü</Link></li>
              <li><Link to="/yetenekler">E-Beyanname</Link></li>
              <li><Link to="/yetenekler">Dijital GİB Modülü</Link></li>
              <li><Link to="/yetenekler">E-SGK</Link></li>
              <li><Link to="/yetenekler">E-Mevzuat</Link></li>
              <li><Link to="/yetenekler">Araçlar</Link></li>
            </ul>
          </div>

          <div className="footer-col">
            <h5>İletişim</h5>
            <ul className="footer-links">
              <li><a href="tel:+905332071900">+90 (533) 207 19 00</a></li>
              <li><a href="mailto:hello@cevfin.com">hello@cevfin.com</a></li>
              <li><a>Yıldız Teknik TEKNOPARK</a></li>
              <li><Link to="/iletisim">Destek Merkezi</Link></li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p>© 2026 CEV Finansal Teknolojiler A.Ş. Tüm hakları saklıdır.</p>
          <p style={{ display: 'flex', gap: 20 }}>
            <a href="#" className="footer-policy-link">Gizlilik Politikası</a>
            <a href="#" className="footer-policy-link">Kullanım Şartları</a>
          </p>
        </div>
      </div>
    </footer>
  );
}
